var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 10C0 4.47716 4.47715 0 10 0H109C114.523 0 119 4.47715 119 10V114H0V10Z",
  fill: "#FF2366",
  fillOpacity: 0.1
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M91 55C91 72.6733 76.6733 87 59 87C41.3267 87 27 72.6733 27 55C27 37.3267 41.3267 23 59 23C76.6733 23 91 37.3267 91 55Z",
  fill: "#FF0068"
});
var _ref4 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M83.0093 23H60.2539C59.7192 23 59.2749 23.4111 59.2349 23.9448C59.0181 26.8413 58.6265 30.8193 57.9414 34.5972C56.9863 39.8657 53.8076 42.5107 52.686 43.8394C57.6592 46.8174 66.8657 51.5098 79.541 54.543C79.5327 54.3569 79.5244 54.1709 79.5156 53.9844C79.5156 53.9844 83.2627 37.3794 84.0307 24.0806C84.0644 23.4937 83.5972 23 83.0093 23Z",
  fill: "#FFCDBE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.8091 66.6479C54.9844 68.0361 56.2944 68.9424 56.397 71.1792C56.5273 74.0205 56.8091 79.6211 57.2622 86.0488C57.2998 86.584 57.7451 87 58.2817 87H76.8652C77.374 87 77.8057 86.627 77.8774 86.123C78.7344 80.0991 79.8486 69.9004 79.6606 58.5264C75.3496 59.0459 62.8955 60.9741 53.8091 66.6479Z",
  fill: "#FFCDBE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.0664 86.0488C60.6133 79.6211 60.332 74.0205 60.2017 71.1792C60.146 69.9673 59.6421 68.8218 58.7959 67.9521C58.1323 67.27 57.29 66.3223 56.4395 65.1514C55.5396 65.6187 54.6597 66.1167 53.8091 66.6479H53.8096C54.9937 68.0469 56.2944 68.9468 56.397 71.1792C56.5273 74.0205 56.8091 79.6211 57.2622 86.0488C57.2998 86.584 57.7451 87 58.2817 87H62.0864C61.5498 87 61.104 86.584 61.0664 86.0488Z",
  fill: "#F7C1B3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.686 43.8389C53.4658 44.3062 54.3496 44.8149 55.335 45.3535C56.0366 44.3291 56.7896 43.4546 57.4937 42.7363C59.6855 40.5 61.1875 37.6782 61.7461 34.5972C62.4307 30.8193 62.8228 26.8408 63.0396 23.9443C63.0796 23.4111 63.5239 23 64.0586 23H60.2544C59.7197 23 59.2749 23.4111 59.2354 23.9448C59.0186 26.8413 58.6265 30.8193 57.9414 34.5972C57.04 39.5698 54.4341 41.6968 52.686 43.8389Z",
  fill: "#F7C1B3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.7185 54.1172C48.7185 59.8472 51.8826 64.4619 54.1252 67.0142C63.5129 60.9902 76.9919 59.354 79.6682 59.0811C79.6472 57.4351 79.5994 55.7637 79.5198 54.0752C66.7415 51.1489 57.5989 46.3804 52.9431 43.54C50.887 45.8794 48.7185 49.4507 48.7185 54.1172Z",
  fill: "#63A1FC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.7087 65.5142C54.6902 62.8364 52.5232 58.8589 52.5232 54.1172C52.5232 50.3628 53.927 47.3164 55.5466 45.0508C54.5652 44.5078 53.6951 43.9985 52.9436 43.54C50.3806 46.4106 48.7185 50.106 48.7185 54.1172C48.7185 58.9316 50.9539 63.3667 54.1252 67.0142C54.9578 66.48 55.8225 65.9814 56.7087 65.5142Z",
  fill: "#4188FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.3784 61.6723L45.2994 69.3413C45.2277 69.8558 45.5859 70.3314 46.0997 70.4037L53.7687 71.4827C54.5987 71.5995 55.1555 70.655 54.6514 69.9858L48.0609 61.237C47.5574 60.5672 46.4952 60.8422 46.3784 61.6723Z",
  fill: "white"
}));
var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  x: 27,
  y: 23,
  width: 64,
  height: 64,
  rx: 32,
  fill: "white"
})));
function SvgSymptomAnalProtrusion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 114,
    viewBox: "0 0 119 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymptomAnalProtrusion);
export default __webpack_public_path__ + "static/media/symptom-Anal-Protrusion.e8bab28cf58c74fdb3fc145357af86c7.svg";
export { ForwardRef as ReactComponent };